import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'helpers/CSSModulesUtil'
import { compose } from 'redux'
import {
  AutoSizer,
  ScrollSync,
} from 'react-virtualized'

import GridContainer from './GridContainer'

import styles from './styles.scss'

class Grid extends Component {
  static propTypes = {
    list: PropTypes.array.isRequired,
    getCache: PropTypes.func.isRequired,
    cellRenderer: PropTypes.func.isRequired,
    headerCellRenderer: PropTypes.func.isRequired,
    leftCellRenderer: PropTypes.func.isRequired,
    leftHeaderCellRenderer: PropTypes.func.isRequired,
    register: PropTypes.func
  }

  onScroll = (callback) => (params) => {
    if (this.props.onScroll)
      this.props.onScroll(params)
    callback(params)
  }

  render() {
    return (
      <AutoSizer disableWidth>
        {({height}) => (
          <ScrollSync>
            {({ onScroll, ...scrollSyncProps }) => (
              <GridContainer
                { ...scrollSyncProps }
                { ...this.props }
                height={height}
                onScroll={this.onScroll(onScroll)}
              />
            )}
          </ScrollSync>
        )}
      </AutoSizer>
    )
  }
}

const withStyles = CSSModules(styles)
const enhance = compose(
  withStyles
)

export default enhance(Grid)
